import {
    Bar, BarChart, CartesianGrid, Cell, Legend, ReferenceLine,
    ResponsiveContainer, Tooltip, XAxis, YAxis,
} from "recharts"

const purple = 'var(--primary-color, #8e24aa)'
const positive = '#16755d'
const negative = '#b02a37'
const axisAmount = new Intl.NumberFormat('es-PE', { notation: 'compact', maximumFractionDigits: 1 })

export const ResultsChart = ({ data, formatAmount }) => (
    <figure className="er-chart">
        <figcaption className="fw-bold mb-2">Ventas y utilidad por período</figcaption>
        <div className="er-chart-scroll">
            <ResponsiveContainer width="100%" height={250} minWidth={420}>
                <BarChart data={data}>
                    <CartesianGrid vertical={false} stroke="#ece4ee" />
                    <XAxis dataKey="label" tick={{ fontSize: 12 }} />
                    <YAxis tickFormatter={value => axisAmount.format(value)} />
                    <Tooltip formatter={value => formatAmount(value)} />
                    <Legend />
                    <ReferenceLine y={0} stroke="#675c6b" />
                    <Bar dataKey="sales" name="Ventas netas" fill={purple} maxBarSize={42} isAnimationActive={false} />
                    <Bar dataKey="profit" name="Utilidad neta" fill={positive} maxBarSize={42} isAnimationActive={false}>
                        {data.map(item => <Cell key={item.label} fill={item.profit < 0 ? negative : positive} />)}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    </figure>
)

export const ProfitWaterfall = ({ previous, current, changes, formatAmount }) => {
    let running = previous
    const steps = [{ label: 'Utilidad anterior', start: 0, end: previous, amount: previous, color: purple }]
    changes.forEach(({ referencia, impact }) => {
        const start = running
        running += impact
        steps.push({ label: referencia, start, end: running, amount: impact, color: impact < 0 ? negative : positive })
    })
    steps.push({ label: 'Utilidad final', start: 0, end: current, amount: current, color: purple })
    const data = steps.map(step => ({ ...step, range: [Math.min(step.start, step.end), Math.max(step.start, step.end)] }))

    return (
        <figure className="er-chart">
            <figcaption className="fw-bold mb-2">Cómo cambió la utilidad</figcaption>
            <div className="er-chart-scroll">
                <ResponsiveContainer width="100%" height={data.length * 32 + 36} minWidth={420}>
                    <BarChart data={data} layout="vertical">
                        <CartesianGrid horizontal={false} stroke="#ece4ee" />
                        <XAxis type="number" tickFormatter={value => axisAmount.format(value)} />
                        <YAxis type="category" dataKey="label" width={150} tick={{ fontSize: 11 }} />
                        <Tooltip formatter={(_, __, item) => [formatAmount(item.payload.amount), 'Importe']} />
                        <ReferenceLine x={0} stroke="#675c6b" />
                        <Bar dataKey="range" maxBarSize={20} isAnimationActive={false}>
                            {data.map(item => <Cell key={item.label} fill={item.color} />)}
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </figure>
    )
}
